import CONSTANTS from '../CONSTANTS';

export const actionSetLastData = (data) => ({
  type: CONSTANTS.WS_SET_DATA,
  data,
});